module.exports = __webpack_public_path__ + "img/title-dver-1.bab5911c.png";